<template>
  <div class="create-consultation-wrapper">
    <div class="prescription-creation-section">
      <button type="button" @click="toggleDropdown" class="create-prescription-button">
        <i class="fas fa-plus-circle"></i> Add Order Set
      </button>

      <div v-if="dropdownOpen && products.length > 0" class="create-consultation-dropdown">
        <button type="button" v-for="product in products" :key="product.id" @click="selectDrug(product.id)"
                class="dropdown-item-button">
          {{ product.fullName }} <span class="quantity">{{ product.quantity }}</span>
        </button>
      </div>
    </div>

    <div v-if="loading" class="loading-indicator">
      <p>Creating prescription...</p>
      <i class="fa fa-spinner fa-spin"></i>
    </div>
    <div v-if="creationError" class="formError">
      {{ creationError }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    consultationId: {
      type: Number,
    },
    productCategorySlug: {
      type: String
    }
  },
  data() {
    return {
      dropdownOpen: false,
      loading: false,
      creationError: null,
      products: []
    };
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
      if (this.dropdownOpen) {
        this.creationError = null;
      }
    },
    selectDrug(drugId) {
      this.dropdownOpen = false;
      this.createPrescription(drugId);
    },
    handleClickOutside(event) {
      if (this.dropdownOpen && !this.$el.contains(event.target)) {
        this.dropdownOpen = false;
      }
    },
    createPrescription(drugId) {
      this.loading = true;
      this.creationError = null;

      axios.post('/api/v1/consultation/create/order-set', {
        drugId: drugId,
        consultationId: this.consultationId,
      })
          .then(response => {
            location.reload();
          })
          .catch(error => {
            this.creationError = 'Failed to create prescription. Please try again.';
            if (error.response && error.response.data && error.response.data.message) {
              this.creationError = error.response.data.message;
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getProducts() {
      axios.get('/api/v1/products')
          .then(response => {
            const data = response.data.data;
            this.products = data.filter(p => (p.category && p.category.slug === this.productCategorySlug));
          })
          .catch(error => {
            console.error('Error fetching products:', error);
          });
    },
  },
  mounted() {
    this.getProducts()
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped>
.create-consultation-wrapper {
  display: inline-block;
  position: relative;
}

.prescription-creation-section {
  position: relative;
  display: inline-block;
}

.create-prescription-button {
  padding: 10px 15px;
  font-size: 14px;
  cursor: pointer;
  border: none;
  background: #4867C0;
  color: #ffffff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.3s ease;
}

.create-prescription-button:hover {
  background-color: #334c94;
}

.create-consultation-dropdown {
  position: absolute;
  background-color: white;
  min-width: 250px;
  max-height: 300px;
  /* Added max-height to limit dropdown size */
  overflow-y: auto;
  /* Enable vertical scrolling */
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  border: 1px solid #ddd;
  border-radius: 4px;
  top: 100%;
  left: 0;
  margin-top: 5px;
  padding: 0;
}

.dropdown-item-button {
  background: none;
  border: none;
  outline: none;
  color: #333;
  padding: 12px 16px;
  text-align: left;
  text-decoration: none;
  display: block;
  width: 100%;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.dropdown-item-button:hover {
  background-color: #f1f1f1;
  color: #333;
}

.loading-indicator {
  margin-top: 15px;
  color: #007bff;
  display: flex;
  align-items: center;
  gap: 8px;
}

.formError {
  color: red;
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: bold;
}

.quantity {
  background-color: #3686c7;
  font-size: 12px;
  color: #fff;
  padding: 2px 5px;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/AddOrderSetButton.vue